$('.expand-all').on('click', 'a', function (e) {
    e.preventDefault();
    toggleAllSections();
});

function toggleAllSections(){
    var expandButton = $('.expand-all a');

    if (expandButton.hasClass('expanded')) {
        expandButton
            .text($(expandButton).attr('data-expand-text'))
            .removeClass('expanded');
        
        closeAllSections();
    } else {
        expandButton
            .text(expandButton.attr('data-collapse-text'))
            .addClass('expanded');

        openAllSections();
    }
}

function openAllSections(){
    $('section.main-section').addClass('active');
}

function closeAllSections(){
    $('section.main-section').removeClass('active');
}